import React, { Component } from 'react'
import Slider from 'react-slick'
import styles from './Carousel.css'
import Vimeo from '../Vimeo'

import "../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../node_modules/slick-carousel/slick/slick-theme.css";



export default class Carousel extends Component {
  render () {
    var settings = {
      infinite: true,
      dots: true,
      arrows: window.innerWidth < 400 ? false : true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: styles.dots,
      autoplay: true,
      nextArrow: <NextArrow/>,
      prevArrow: <PrevArrow/>,
    }
    return (
      <div className={styles.cont}>
        <Slider {...settings}>
          {this.props.carousel.map( (item, k) => <Item key={k} id={k} {...item}/> )}
        </Slider>
      </div>
    )
  }
}

class Item extends Component {

  render () {
    return (
      <div
        className={'slick-slide'}
        data-index={this.props.id}
        style={{
          width: document.body.scrollWidth,
          cursor: this.props.url ? 'pointer' : 'default',
        }}
      >
        {
          this.props.video ? (
            <div className={styles.img}>
              <Vimeo video={this.props.video} id={this.props.id} image={this.props.image}/>
            </div>
          ) : this.props.image && (
            <div
              className={styles.img}
              style={{
                backgroundImage: 'url('+this.props.image+')'
              }}
            >
              <div className={styles.body} dangerouslySetInnerHTML={{__html: this.props.body}}/>
            </div>
          )
        }
      </div>
    )
  }
}


class NextArrow extends Component {
  render () {
    return (
      <div
        className={styles.nextArrow}
        onClick={this.props.onClick}
        style={this.props.style}
      />
    )
  }
}

class PrevArrow extends Component {
  render () {
    return (
      <div
        className={styles.prevArrow}
        onClick={this.props.onClick}
        style={this.props.style}
      />
    )
  }
}




// WEBPACK FOOTER //
// ./src/Rist/modules/Carousel/index.js